import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, styled, Typography } from "@mui/material"
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useEffect, useState } from "react"
import dayjs from "dayjs"
import { capitalize, formatTime } from "../../../../helpers"
import TimeInput from "../../../../components/TimeInput"

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  '&.MuiAccordion-root': {
    border: 'none',
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
  },
}))

// Custom styled AccordionSummary
const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  padding: theme.spacing(0, 2),
  '& .MuiAccordionSummary-content': {
    margin: theme.spacing(1, 0),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: theme.palette.primary.main,
  },
}))

const TimeBlockGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
}))

const TimeBlock = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: theme.spacing(1.5),
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  transition: 'all 0.3s ease',
  '&:hover': {
    borderColor: theme.palette.primary.main,
    boxShadow: theme.shadows[2],
  },
}))

// Horarios por defecto: 7 días con bloques de horario completo
const initData = [
  {
    day: 1,
    blocks: [
      {
        start: '00:00:00',
        end: '23:59:59',
      }
    ]
  },
  {
    day: 2,
    blocks: [
      {
        start: '00:00:00',
        end: '23:59:59',
      }
    ]
  },
  {
    day: 3,
    blocks: [
      {
        start: '00:00:00',
        end: '23:59:59',
      }
    ]
  },
  {
    day: 4,
    blocks: [
      {
        start: '00:00:00',
        end: '23:59:59',
      }
    ]
  },
  {
    day: 5,
    blocks: [
      {
        start: '00:00:00',
        end: '23:59:59',
      }
    ]
  },
  {
    day: 6,
    blocks: [
      {
        start: '00:00:00',
        end: '23:59:59',
      }
    ]
  },
  {
    day: 0,
    blocks: [
      {
        start: '00:00:00',
        end: '23:59:59',
      }
    ]
  }
]

export default function FormContactosSchedule({ 
  data, 
  onChange = () => {}, 
  edit = false
}) {
  const [schedules, setSchedules] = useState(data || initData)
  const [openDialog, setOpenDialog] = useState(null)

  console.log(data, schedules);
  
  useEffect(() => {
    onChange(schedules)
  }, [schedules])

  const handleAddBlock = (day) => {
    const dayIndex = schedules.findIndex(s => s.day === day);
    setOpenDialog({
      day,
      block: null,
      prevBlock: schedules[dayIndex].blocks[schedules[dayIndex].blocks.length - 1],
    })
  }

  const handleEditBlock = (day, index) => {
    const schedule = schedules.find(s => s.day === day)
    setOpenDialog({
      day,
      block: schedule.blocks[index],
      nextBlock: schedule.blocks[index + 1],
      prevBlock: schedule.blocks[index - 1],
      index
    })
  }

  const handleDeleteBlock = (day, index) => {
    setSchedules(prev => {
      const newSchedules = [...prev]
      const dayIndex = newSchedules.findIndex(s => s.day === day)
      newSchedules[dayIndex].blocks.splice(index, 1)
      return newSchedules
    })
  }

  const handleSaveBlock = (block) => {
    if (openDialog.block) {
      setSchedules(prev => {
        const newSchedules = [...prev]
        const day = newSchedules.findIndex(s => s.day === openDialog.day)
        newSchedules[day].blocks[openDialog.index] = block
        return newSchedules
      })
    } else {
      setSchedules(prev => {
        const newSchedules = [...prev]
        const day = newSchedules.findIndex(s => s.day === openDialog.day)
        newSchedules[day].blocks.push(block)
        return newSchedules
      })
    }
    setOpenDialog(null)
  }

  // Ordenar los días de la semana comenzando por lunes (1) hasta domingo (0)
  const sortedSchedules = [...schedules].sort((a, b) => {
    if (a.day === 0) return 1;
    if (b.day === 0) return -1;
    return a.day - b.day;
  });

  return (
    <Paper
      elevation={1}
      sx={{ 
        maxWidth: 600, 
        mx: 'auto', 
        p: 2,
        border: '1px solid',
        borderColor: 'divider'
      }}
    >
      <Typography variant="h6" gutterBottom align="center">
        Horario de contacto
      </Typography>
      {sortedSchedules.map((schedule, index) => {
        const firstBlock = schedule.blocks[0]
        const lastBlock = schedule.blocks[schedule.blocks.length - 1]

        return (
          <StyledAccordion key={index}>
                         <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
               <Typography>{capitalize(dayjs().day(schedule.day).format('dddd'))}</Typography>
               <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
                 {schedule.blocks.length > 0 ? `${formatTime(parseTime(schedule.blocks[0].start))} - ${formatTime(parseTime(schedule.blocks[schedule.blocks.length - 1].end))}` : 'Sin bloques'}
               </Typography>
             </StyledAccordionSummary>
            <AccordionDetails>
              <TimeBlockGrid>
                {schedule.blocks.map((block, bi) => (
                  <TimeBlock key={bi}>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      Bloque {bi + 1}
                    </Typography>
                    <Typography variant="subtitle2" gutterBottom>
                      {formatTime(parseTime(block.start))} - {formatTime(parseTime(block.end))}
                    </Typography>
                    {edit && (
                      <Box sx={{ mt: 1, display: 'flex', justifyContent: 'flex-end' }}>
                        <IconButton size="small" onClick={() => handleEditBlock(schedule.day, bi)}>
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => handleDeleteBlock(schedule.day, bi)}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    )}
                  </TimeBlock>
                ))}
                {edit && (
                  <Button 
                    variant="outlined" 
                    startIcon={<AddIcon />} 
                    onClick={() => handleAddBlock(schedule.day)}
                    sx={{ height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    Agregar bloque
                  </Button>
                )}
              </TimeBlockGrid>
            </AccordionDetails>
          </StyledAccordion>
        )
      })}
      {openDialog && (
        <BlockDialog 
          open={Boolean(openDialog)} 
          onClose={() => setOpenDialog(null)} 
          onSave={handleSaveBlock}
          block={openDialog.block}
          nextBlock={openDialog.nextBlock}
          prevBlock={openDialog.prevBlock}
        />
      )}
    </Paper>
  )
}

const parseTime = (timeStr) => {
  const [h, m, s] = timeStr.split(':').map(Number);
  const date = new Date();
  date.setHours(h);
  date.setMinutes(m);
  date.setSeconds(s);
  return date;
};

const addMinutes = (timeStr, minutes) => {
  const time = parseTime(timeStr);
  return dayjs(time).add(minutes, 'minute').format('HH:mm:ss')
}

const subMinutes = (timeStr, minutes) => {
  const time = parseTime(timeStr);
  return dayjs(time).subtract(minutes, 'minute').format('HH:mm:ss')
}

function BlockDialog({ open, onClose, onSave, block, nextBlock, prevBlock }) {
  const [formData, setFormData] = useState(block || {
    start: prevBlock?.end || '00:00:00',
    end: nextBlock?.start || '23:59:59',
  })

  useEffect(() => {
    if (!block) {
      let start = prevBlock?.end || '00:00:00'
      let end = nextBlock?.start || '23:59:59'
      
      if (end === start && end !== '00:00:00') {
        end = addMinutes(start, 60)
      }

      setFormData({
        start,
        end,
      })
    } else {
      setFormData({
        start: block.start,
        end: block.end,
      })
    }
  }, [block, nextBlock, prevBlock])

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSave(formData)
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>{block ? 'Editar bloque de horario' : 'Agregar bloque de horario'}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Min: {prevBlock?.end || '00:00:00'} - Max: {nextBlock?.start || '23:59:59'}
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TimeInput
              label="Hora inicio"
              value={formData.start}
              onChange={(value) => handleChange('start', value)}
              minTime={prevBlock?.end || '00:00:00'}
              maxTime={subMinutes(nextBlock?.start || '23:59:59', 15)}
              interval={15}
              fullWidth
            />
            <TimeInput
              label="Hora fin"
              value={formData.end}
              onChange={(value) => handleChange('end', value)}
              minTime={addMinutes(formData.start || '00:00:00', 15)}
              maxTime={nextBlock?.start || '23:59:59'}
              interval={15}
              fullWidth
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="contained" color="primary">Guardar</Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}
